import React from "react";
import ChatbotEdit from "./chatbot";
import Header from "../../common/Header";
import Sidebar from "../../common/Sidebar";
const ChatbotHolder = () => {

    return (
        <>
            <div id='layout-wrapper'>
                <Header />
                <Sidebar />
                <div className='page-content'>

                    <div className="main-content">
                        <ChatbotEdit />

                    </div>
                </div>
            </div>
        </>
    )
}


export default ChatbotHolder;